import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
// import { environment } from "@app/../environments/environment";
import { UsersService } from "@shared/services/users/users.service";
import { ClickarUtilsService } from "@shared/services/utils/clickar-utils.service";
import { OAuthService } from "angular-oauth2-oidc";
import { firstValueFrom, Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";

@Injectable({
	providedIn: "root"
})
export class LoginGuard implements CanActivate, CanActivateChild {
	constructor(
		private userService: UsersService,
		private router: Router,
		private oauthService: OAuthService,
		private utils: ClickarUtilsService
	) { }

	canActivate(): Promise<boolean> {
		return this.oauthService.tryLoginCodeFlow().then(() => {
			if (this.oauthService.hasValidAccessToken()) {
				return firstValueFrom(this.userService.getProfileOfLoggedUser().pipe(
					map(res => {
						// if (res == null || res.username == null) {
						// 	window.location.href = environment.adfsUrl;
						// 	return false;
						// }
						if (this.utils.isNullOrUndefined(res.consent1)
							|| this.utils.isNullOrUndefined(res.consent2)
							|| this.utils.isNullOrUndefined(res.consent3)) {
							this.router.navigate(["/private/privacy"]);
							return false;
						}
						// console.log("return", res.flgEnabled)
						return res.flgEnabled;
					})
				));
			}
			this.oauthService.initCodeFlow();
			return false;
		});
	}
	/*
	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean> | Promise<boolean> | boolean {
		console.log("LOGIN GUARD");

		const reqUrl = next.pathFromRoot.map(el => el.url).join("/");
		console.log("CAN_ACTIVATE>>>>" + reqUrl);

		if (state.url.includes("privacy")) {
			return true;
		}

		return this.userService.getProfileOfLoggedUser().pipe(
			map(res => {
				if (res == null || res.username == null) {
					window.location.href = environment.adfsUrl;
					return false;
				}
				if (this.utils.isNullOrUndefined(res.consent1)
					|| this.utils.isNullOrUndefined(res.consent2)
					|| this.utils.isNullOrUndefined(res.consent3)) {
					this.router.navigate(["/private/privacy"]);
					return false;
				}
				// console.log("return", res.flgEnabled)
				return res.flgEnabled;
			})
		);
	}
	*/
	canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		const reqUrl = childRoute.pathFromRoot.map(el => el.url).join("/");
		if (state.url.includes("privacy")) {
			return true;
		}

		return this.userService.getProfileOfLoggedUser().pipe(
			map(res => {
				if (this.utils.isNullOrUndefined(res.consent1)
					|| this.utils.isNullOrUndefined(res.consent2)
					|| this.utils.isNullOrUndefined(res.consent3)) {
					this.router.navigate(["/private/privacy"]);
					return false;
				}
				return res.flgEnabled;

			})
		).pipe(
			catchError(err => {
				console.error(err);
				this.oauthService.initCodeFlow();
				return of(false);
			})
		);
	}
}